import React from 'react'

import dynamic from 'next/dynamic'

const DynamicQualifiedWidget = dynamic(() => import('../widget/qualified'))

export const MessengerWidget: React.FC = () => {
  return <DynamicQualifiedWidget />
}
